var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttentionmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "exclamation-mark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.21,
    height: 16.21,
    viewBox: "0 0 16.21 16.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M8.105,0A8.105,8.105,0,1,0,16.21,8.105,8.106,8.106,0,0,0,8.105,0Zm0,14.691a6.585,6.585,0,1,1,6.585-6.585A6.585,6.585,0,0,1,8.105,14.691Zm0-11.136c-.581,0-1.02.3-1.02.792V8.835c0,.49.439.792,1.02.792s1.02-.315,1.02-.792V4.347C9.125,3.869,8.672,3.555,8.106,3.555Zm0,7.083A1.012,1.012,0,1,0,9.117,11.65,1.013,1.013,0,0,0,8.106,10.638Z",
    fill: "#e2574c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M8.105,0A8.105,8.105,0,1,0,16.21,8.105,8.106,8.106,0,0,0,8.105,0Zm0,14.691a6.585,6.585,0,1,1,6.585-6.585A6.585,6.585,0,0,1,8.105,14.691Zm0-11.136c-.581,0-1.02.3-1.02.792V8.835c0,.49.439.792,1.02.792s1.02-.315,1.02-.792V4.347C9.125,3.869,8.672,3.555,8.106,3.555Zm0,7.083A1.012,1.012,0,1,0,9.117,11.65,1.013,1.013,0,0,0,8.106,10.638Z",
    fill: "#e2574c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionmark);
export default __webpack_public_path__ + "static/media/attentionmark.4017837e39eccaca39587f52f17566cb.svg";
export { ForwardRef as ReactComponent };